/** Данные для авторизации API */
export const token = 'd55efb6a-3d0f-4b71-9064-6094926b2269';
export const cohort = 'cohort-60';
